import { Linkedin as Linkedin_kojaro } from './Linkedin.kojaro';
import { Linkedin as Linkedin_phosphor } from './Linkedin.phosphor';
import { Linkedin as Linkedin_zoomg } from './Linkedin.zoomg';
import { Linkedin as Linkedin_zoomit } from './Linkedin.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Linkedin_kojaro;

    case 'zoomg':
      return Linkedin_zoomg;

    case 'phosphor':
      return Linkedin_phosphor;

    default:
      return Linkedin_zoomit;
  }
};

export const Linkedin = IconRenderer();
